export const translations = {
  en: {
    // Header
    nav: {
      about: "About",
      services: "Services",
      team: "Team",
      contact: "Contact",
      bookConsultation: "Book Consultation"
    },
    
    // Hero Section
    hero: {
      headline: "Resolving Disputes with Expertise and Impartiality",
      subheadline: "Professional mediation services for businesses facing conflicts between staff members, management and staff, shareholders, clients and suppliers.",
      cta: "Schedule a Consultation",
      contactUs: "Contact Us"
    },
    
    // About Section
    about: {
      title: "About Mediation Partners",
      description: "Mediation Partners specializes in corporate conflict resolution, providing expert mediation services that help businesses emerge from conflicts by co-creating their own solutions: a tailor-made outcome that is faster, more serene, and more sustainable.",
      values: {
        impartial: {
          title: "Impartial",
          description: "We maintain strict neutrality to ensure fair outcomes for all parties involved."
        },
        confidential: {
          title: "Confidential",
          description: "All mediation sessions are conducted with complete discretion and privacy."
        },
        efficient: {
          title: "Efficient",
          description: "We help resolve disputes quickly, saving time and resources for your business."
        },
        independent: {
          title: "Independent",
          description: "Complete independence in our approach and decision-making process."
        },
        neutral: {
          title: "Neutral",
          description: "We maintain a neutral stance to facilitate constructive dialogue between all parties."
        }
      }
    },
    
    // Services Section
    services: {
      title: "Our Mediation Services",
      subtitle: "Specialized corporate mediation for various business conflicts",
      shareholder: {
        title: "Shareholder Disputes",
        description: "Approach conflicts between shareholders, partners, and executives with professional mediation that protects business continuity and relationships.",
        features: [
          "Partnership disagreements",
          "Equity distribution conflicts",
          "Strategic direction disputes",
          "Exit strategy negotiations"
        ]
      },
      client: {
        title: "Client Disputes",
        description: "Transform client conflicts into opportunities: resolve disagreements professionally, cultivate relationships, and protect your brand image.",
        features: [
          "Contract disagreements",
          "Service delivery conflicts",
          "Payment disputes",
          "Expectation management"
        ]
      },
      supplier: {
        title: "Supplier Conflicts",
        description: "Address disputes with suppliers and vendors to maintain supply chain integrity and business operations.",
        features: [
          "Quality disagreements",
          "Delivery conflicts",
          "Contract interpretation",
          "Price negotiation issues"
        ]
      },
      team: {
        title: "Team Difficulties - Social Relations",
        description: "Facilitate resolution of internal conflicts and improve workplace relationships to maintain a healthy work environment.",
        features: [
          "Interpersonal conflicts",
          "Communication breakdowns",
          "Team dynamics issues",
          "Union negotiations"
        ]
      },
      training: {
        title: "Corporate Training on Conflict Prevention",
        description: "Proactive training programs to prevent conflicts and develop communication skills within your organization.",
        features: [
          "Conflict management workshops",
          "Communication skills training",
          "Nonviolent communication approach",
          "Preventive strategies development"
        ]
      }
    },
    
    // Team Section
    team: {
      title: "Our Certified Mediators",
      members: [
        // TEMPORAIREMENT MASQUÉ - Doris Sessolo
        // {
        //   name: "Doris Sessolo",
        //   role: "Partner",
        //   bio: "Doris specializes in team mediation and social relations, bringing a deep understanding of workplace dynamics and conflict resolution. Her empathetic approach helps restore harmony in professional environments."
        // },
        {
          name: "Christophe Cogels",
          role: "Partner",
          bio: "Christophe has extensive experience in the business world and organizational conflict management. He specializes in supporting family businesses, an environment where economic challenges intertwine with emotional and relational dynamics.\n\nHis areas of intervention include:\n• Shareholder conflicts and governance issues,\n• Disputes with clients and suppliers, often amplified by reputation or business continuity issues,\n• Social conflicts within SMEs, including social dialogue, internal tensions, and sensitive restructurings.\n\nChristophe has led an investment bank as well as several SMEs, giving him a refined understanding of the operational, financial, and human realities that business leaders face. He is a mediator certified by the Federal Mediation Commission in civil and commercial, social, and family matters.\n\nIn parallel, he heads a non-profit organization dedicated to preserving social bonds within families, reinforcing his comprehensive approach to relational dynamics, whether professional or private."
        }
        // TEMPORAIREMENT MASQUÉ - Michel Caldana
        // {
        //   name: "Michel Caldana",
        //   role: "Partner",
        //   bio: "Michel is a mediator in civil and commercial mediation and social mediation.\n\nWith a civil engineering background, Michel brings over thirty years of experience in analyzing complex situations and supporting business leaders to the service of mediation. His career, which combines industry, corporate management, consulting and judicial functions, has allowed him to develop expertise in understanding technical, economic and legal issues, particularly in the context of companies in difficulty.\n\nLay judge at the Walloon Brabant Enterprise Court since 2018, he sits notably in the amicable settlement chamber, where he supports parties in seeking negotiated solutions. Holder of an inter-university certificate in mediation (UCLouvain), he has made active listening, reformulation and tension management the heart of his practice.\n\nHis in-depth knowledge of bankruptcy and judicial reorganization mechanisms, combined with his experience in supporting leaders in sensitive contexts, enables him to quickly create a climate of trust with stakeholders in difficulty and help them identify constructive solutions.\n\nHe works primarily in civil and commercial mediation, with particular attention to situations involving companies and their leaders."
        // }
      ]
    },
    
    // FAQ Section
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "What is corporate mediation?",
          answer: "Corporate mediation is a confidential process where a neutral third party helps businesses resolve disputes through facilitated negotiation, avoiding costly litigation."
        },
        {
          question: "How long does mediation typically take?",
          answer: "Most mediations are resolved in 3-5 sessions, depending on the complexity of the dispute. Each session typically lasts 2-4 hours. The schedule of sessions is organized between the parties and the mediator."
        },
        {
          question: "Is mediation legally binding?",
          answer: "Mediation agreements can be made legally binding. Our mediators are certified by the Federal Mediation Commission and can help create enforceable settlement agreements."
        },
        {
          question: "What is the cost of mediation?",
          answer: "Costs vary based on the complexity and duration of the mediation. The fees are shared between the parties and this is subject to an agreement. Contact us for a detailed quote tailored to your specific situation."
        },
        {
          question: "Where do mediations take place?",
          answer: "Mediations must take place in a neutral location. This should be as close as possible to the parties and our mediators travel throughout Belgium."
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: "Schedule a Consultation",
      subtitle: "This initial consultation is free and allows you to understand what mediation can bring you. We commit to contact you within 24 hours. Please plan for 30 minutes.",
      form: {
        fullName: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        company: "Company Name",
        disputeType: "Type of Dispute",
        preferredDay: "Preferred Day",
        preferredTime: "Preferred Time",
        alternativeSlots: "Alternative time slots",
        additionalInfo: "Additional Information",
        placeholder: "If there are other non-confidential elements you want to share at this stage you can communicate them to us here. Some mediations require a quick start. If necessary, do not hesitate to mention it.",
        selectType: "Select dispute type",
        selectDay: "Select a day",
        selectTime: "Select a time slot",
        types: {
          shareholder: "Shareholder Dispute",
          client: "Client Dispute",
          supplier: "Supplier Conflict",
          social: "Social Mediation",
          training: "Corporate Training",
          other: "Other"
        },
        submit: "Book Consultation",
        submitting: "Submitting...",
        required: " *"
      }
    },
    
    // Contact Section
    contact: {
      title: "Get In Touch",
      subtitle: "Have questions? We're here to help",
      info: {
        title: "Contact Information",
        email: "Email",
        phone: "Phone",
        location: "Location",
        locationValue: "Belgium"
      },
      form: {
        title: "Send us a message",
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send Message",
        submitting: "Sending...",
        required: " *"
      }
    },
    
    // Footer
    footer: {
      description: "Professional corporate mediation services for businesses.",
      quickLinks: "Quick Links",
      contact: "Contact",
      copyright: "All rights reserved."
    },
    
    // Toast Messages
    toast: {
      contactSuccess: "Thank you for your message. We will contact you within 24 hours.",
      bookingSuccess: "Your consultation has been scheduled. You will receive a confirmation email shortly.",
      error: "An error occurred. Please try again."
    }
  },
  
  fr: {
    // Header
    nav: {
      about: "À propos",
      services: "Services",
      team: "Équipe",
      contact: "Contact",
      bookConsultation: "Réserver une consultation"
    },
    
    // Hero Section
    hero: {
      headline: "Résoudre les litiges avec expertise et impartialité",
      subheadline: "Services de médiation professionnelle pour les entreprises confrontées à des conflits entre les membres du personnel, la direction et le personnel, les actionnaires, clients et fournisseurs.",
      cta: "Planifier une consultation",
      contactUs: "Nous contacter"
    },
    
    // About Section
    about: {
      title: "À propos de Mediation Partners",
      description: "Mediation Partners est spécialisée dans la résolution de conflits d'entreprise, fournissant des services de médiation experts qui aident les entreprises à sortir des conflits en co-créant leurs propres solutions: une issue sur mesure plus rapide, plus sereine et plus pérenne.",
      values: {
        impartial: {
          title: "Impartial",
          description: "Nous traitons les parties de manière égale pour garantir des résultats équitables pour toutes les parties."
        },
        confidential: {
          title: "Confidentiel",
          description: "Toutes les parties s'engagent à mener les séances de médiation avec une discrétion et une confidentialité totales."
        },
        efficient: {
          title: "Efficace",
          description: "Nous aidons à résoudre les litiges rapidement, économisant du temps et des ressources pour votre entreprise."
        },
        independent: {
          title: "Indépendant",
          description: "Nous ne sommes tributaires de personne et apprécions les situations en toute liberté."
        },
        neutral: {
          title: "Neutre",
          description: "Pour faciliter le dialogue entre toutes les parties nous ne jugeons pas et ne donnons pas d'opinions."
        }
      }
    },
    
    // Services Section
    services: {
      title: "Nos services de médiation",
      subtitle: "Médiation d'entreprise spécialisée pour divers conflits commerciaux",
      shareholder: {
        title: "Conflits entre actionnaires",
        description: "Appréhendez les conflits entre actionnaires, partenaires et dirigeants avec une médiation professionnelle qui protège la continuité des affaires et les relations.",
        features: [
          "Désaccords entre partenaires",
          "Conflits de répartition des capitaux",
          "Litiges sur l'orientation stratégique",
          "Négociations de stratégies de sortie"
        ]
      },
      client: {
        title: "Litiges avec les clients",
        description: "Transformez les conflits avec les clients en opportunités: réglez les désaccords avec professionnalisme, cultivez les relations et protégez votre image de marque.",
        features: [
          "Désaccords contractuels",
          "Conflits de prestation de services",
          "Litiges de paiement",
          "Gestion des attentes"
        ]
      },
      supplier: {
        title: "Conflits avec les fournisseurs",
        description: "Traitez les litiges avec les fournisseurs et les vendeurs pour maintenir l'intégrité de la chaîne d'approvisionnement et les opérations commerciales.",
        features: [
          "Désaccords sur la qualité",
          "Conflits de livraison",
          "Interprétation des contrats",
          "Problèmes de négociation de prix"
        ]
      },
      team: {
        title: "Difficultés dans les équipes - Relations sociales",
        description: "Faciliter la résolution des conflits internes et améliorer les relations de travail pour maintenir un environnement professionnel sain.",
        features: [
          "Conflits interpersonnels",
          "Ruptures de communication",
          "Problèmes de dynamique d'équipe",
          "Négociations syndicales"
        ]
      },
      training: {
        title: "Formation en entreprise sur la prévention des conflits",
        description: "Programmes de formation proactifs pour prévenir les conflits et développer les compétences en communication au sein de votre organisation.",
        features: [
          "Ateliers de gestion des conflits",
          "Formation aux compétences en communication",
          "Approche par la communication non violente",
          "Développement de stratégies préventives"
        ]
      }
    },
    
    // Team Section
    team: {
      title: "Nos médiateurs agréés",
      members: [
        // TEMPORAIREMENT MASQUÉ - Doris Sessolo
        // {
        //   name: "Doris Sessolo",
        //   role: "Associée",
        //   bio: "Doris se spécialise dans la médiation d'équipe et les relations sociales, apportant une compréhension approfondie de la dynamique du lieu de travail et de la résolution de conflits. Son approche empathique aide à restaurer l'harmonie dans les environnements professionnels."
        // },
        {
          name: "Christophe Cogels",
          role: "Associé",
          bio: "Christophe possède une longue expérience du monde de l'entreprise et de la gestion des conflits organisationnels. Il s'est spécialisé dans l'accompagnement des entreprises familiales, un environnement où les enjeux économiques se mêlent aux dynamiques émotionnelles et relationnelles.\n\nSon champ d'intervention couvre :\n• les conflits entre actionnaires et les problématiques de gouvernance, organes d'administration et direction\n• les conflits au sein des PME, incluant dialogue social, tensions internes et restructurations sensibles.\n\nChristophe a dirigé une banque d'affaires ainsi que plusieurs PME, ce qui lui confère une compréhension fine des réalités opérationnelles, financières et humaines auxquelles les dirigeants sont confrontés. Il est médiateur agréé par la Commission Fédérale de Médiation en matières civiles et commerciales, sociales et familiales.\n\nParallèlement, il est responsable d'une ASBL dédiée à la préservation du lien social au sein des familles, renforçant son approche globale des dynamiques relationnelles, qu'elles soient professionnelles ou privées."
        }
        // TEMPORAIREMENT MASQUÉ - Michel Caldana
        // {
        //   name: "Michel Caldana",
        //   role: "Associé",
        //   bio: "Michel est médiateur en médiation civile et commerciale et médiation sociale.\n\nIngénieur civil de formation, Michel met aujourd'hui plus de trente ans d'expérience dans l'analyse de situations complexes et l'accompagnement de dirigeants au service de la médiation. Son parcours, qui conjugue industrie, direction d'entreprise, conseil et fonction judiciaire, lui a permis de développer une expertise dans la compréhension des enjeux techniques, économiques et juridiques, en particulier dans les contextes d'entreprises en difficulté.\n\nJuge consulaire au Tribunal de l'entreprise du Brabant wallon depuis 2018, il siège notamment en chambre de règlement amiable, où il accompagne les parties dans la recherche de solutions négociées. Titulaire d'un certificat inter-universitaire en médiation (UCLouvain), il a fait de l'écoute active, de la reformulation et de la gestion des tensions le cœur de sa pratique.\n\nSa connaissance approfondie des dispositifs de faillite et de réorganisation judiciaire, alliée à son expérience d'accompagnement de dirigeants dans des contextes sensibles, lui permet de créer rapidement un climat de confiance avec des interlocuteurs en difficulté et de les aider à identifier des solutions constructives.\n\nIl intervient principalement en médiation civile et commerciale, avec une attention particulière portée aux situations impliquant des entreprises et leurs dirigeants"
        // }
      ]
    },
    
    // FAQ Section
    faq: {
      title: "Questions fréquemment posées",
      items: [
        {
          question: "Qu'est-ce que la médiation d'entreprise?",
          answer: "La médiation d'entreprise est un processus confidentiel où un tiers neutre aide les entreprises à résoudre les litiges par le biais de négociations facilitées, évitant ainsi des litiges coûteux."
        },
        {
          question: "Combien de temps dure généralement la médiation?",
          answer: "La plupart des médiations sont résolues en 3 à 5 séances, selon la complexité du litige. Chaque séance dure généralement 2 à 4 heures. Le planning des séances est organisé entre les parties et le médiateur."
        },
        {
          question: "La médiation est-elle juridiquement contraignante?",
          answer: "Les accords de médiations peuvent être rendus juridiquement contraignants, nos médiateurs sont agréés par la Commission Fédérale de médiation et peuvent aider à créer des accords de règlement exécutoires."
        },
        {
          question: "Quel est le coût de la médiation?",
          answer: "Les coûts varient en fonction de la complexité et de la durée de la médiation. Les frais sont partagés entre les parties et ceci fait l'objet d'un accord. Contactez-nous pour obtenir un devis détaillé adapté à votre situation spécifique."
        },
        {
          question: "Où se passent les médiations?",
          answer: "Les médiations doivent se passer dans un lieu neutre. Celui-ci doit être le plus proche possible des parties et nos médiateurs se déplacent dans toute la Belgique."
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: "Planifier une consultation",
      subtitle: "Cette première prise de connaissance est gratuite et vous permet de comprendre ce que la médiation peut vous apporter. Nous nous engageons à vous contacter dans les 24 heures. Prévoir 1/2 heure.",
      form: {
        fullName: "Nom complet",
        email: "Adresse e-mail",
        phone: "Numéro de téléphone",
        company: "Nom de l'entreprise",
        disputeType: "Type de litige",
        preferredDay: "Jour préféré",
        preferredTime: "Heure préférée",
        alternativeSlots: "Créneaux horaires alternatifs",
        additionalInfo: "Informations complémentaires",
        placeholder: "S'il y a d'autres éléments non confidentiels que vous voulez partager à ce stade vous pouvez nous les communiquer ici. Certaines médiations nécessitent un démarrage rapide. Si nécessaire, n'hésitez pas à le mentionner.",
        selectType: "Sélectionner le type de litige",
        selectDay: "Sélectionner un jour",
        selectTime: "Sélectionner un créneau",
        types: {
          shareholder: "Conflit entre actionnaires",
          client: "Litige avec un client",
          supplier: "Conflit avec un fournisseur",
          social: "Médiation sociale",
          training: "Formation en entreprise",
          other: "Autre"
        },
        submit: "Réserver une consultation",
        submitting: "Envoi en cours...",
        required: " *"
      }
    },
    
    // Contact Section
    contact: {
      title: "Contactez-nous",
      subtitle: "Vous avez des questions? Nous sommes là pour vous aider",
      info: {
        title: "Coordonnées",
        email: "E-mail",
        phone: "Téléphone",
        location: "Localisation",
        locationValue: "Belgique"
      },
      form: {
        title: "Envoyez-nous un message",
        name: "Nom",
        email: "E-mail",
        phone: "Téléphone",
        message: "Message",
        submit: "Envoyer le message",
        submitting: "Envoi...",
        required: " *"
      }
    },
    
    // Footer
    footer: {
      description: "Services de médiation d'entreprise professionnels pour les entreprises.",
      quickLinks: "Liens rapides",
      contact: "Contact",
      copyright: "Tous droits réservés."
    },
    
    // Toast Messages
    toast: {
      contactSuccess: "Merci pour votre message. Nous vous contactons sous 24 heures.",
      bookingSuccess: "Votre consultation a été planifiée. Vous recevrez un e-mail de confirmation sous peu.",
      error: "Une erreur s'est produite. Veuillez réessayer."
    }
  },
  
  nl: {
    // Header
    nav: {
      about: "Over ons",
      services: "Diensten",
      team: "Team",
      contact: "Contact",
      bookConsultation: "Boek een consultatie"
    },
    
    // Hero Section
    hero: {
      headline: "Geschillen oplossen met expertise en onpartijdigheid",
      subheadline: "Professionele bemiddelingsdiensten voor bedrijven die te maken hebben met conflicten tussen personeelsleden, het management en het personeel, aandeelhouders, klanten en leveranciers.",
      cta: "Plan een consultatie",
      contactUs: "Neem contact op"
    },
    
    // About Section
    about: {
      title: "Over Mediation Partners",
      description: "Mediation Partners is gespecialiseerd in bedrijfsconflictoplossing en biedt deskundige bemiddelingsdiensten die bedrijven helpen uit conflicten te komen door samen hun eigen oplossingen te creëren: een oplossing op maat die sneller, sereen en duurzamer is.",
      values: {
        impartial: {
          title: "Onpartijdig",
          description: "We handhaven strikte neutraliteit om eerlijke uitkomsten voor alle betrokken partijen te waarborgen."
        },
        confidential: {
          title: "Vertrouwelijk",
          description: "Alle bemiddelingssessies worden uitgevoerd met volledige discretie en privacy."
        },
        efficient: {
          title: "Efficiënt",
          description: "We helpen geschillen snel op te lossen, waardoor tijd en middelen voor uw bedrijf worden bespaard."
        },
        independent: {
          title: "Onafhankelijk",
          description: "Volledige onafhankelijkheid in onze aanpak en besluitvormingsproces."
        },
        neutral: {
          title: "Neutraal",
          description: "We handhaven een neutrale positie om constructieve dialoog tussen alle partijen te faciliteren."
        }
      }
    },
    
    // Services Section
    services: {
      title: "Onze bemiddelingsdiensten",
      subtitle: "Gespecialiseerde bedrijfsbemiddeling voor verschillende zakelijke conflicten",
      shareholder: {
        title: "Aandeelhoudersgeschillen",
        description: "Benader conflicten tussen aandeelhouders, partners en leidinggevenden met professionele bemiddeling die bedrijfscontinuïteit en relaties beschermt.",
        features: [
          "Partnerschapsmeningsverschillen",
          "Conflicten over vermogensverdeling",
          "Geschillen over strategische richting",
          "Exitstrategie-onderhandelingen"
        ]
      },
      client: {
        title: "Klantgeschillen",
        description: "Transformeer klantconflicten in kansen: los meningsverschillen professioneel op, koester relaties en bescherm uw merkimago.",
        features: [
          "Contractuele meningsverschillen",
          "Conflicten over dienstverlening",
          "Betalingsgeschillen",
          "Verwachtingsmanagement"
        ]
      },
      supplier: {
        title: "Leveranciersconflicten",
        description: "Pak geschillen met leveranciers en verkopers aan om de integriteit van de toeleveringsketen en bedrijfsactiviteiten te behouden.",
        features: [
          "Kwaliteitsmeningsverschillen",
          "Leveringsconflicten",
          "Contractinterpretatie",
          "Problemen met prijsonderhandelingen"
        ]
      },
      team: {
        title: "Teammoeilijkheden - Sociale relaties",
        description: "Faciliteer de oplossing van interne conflicten en verbeter arbeidsrelaties om een gezonde werkomgeving te behouden.",
        features: [
          "Interpersoonlijke conflicten",
          "Communicatieproblemen",
          "Teamdynamiek problemen",
          "Vakbondsonderhandelingen"
        ]
      },
      training: {
        title: "Bedrijfstraining over conflictpreventie",
        description: "Proactieve trainingsprogramma's om conflicten te voorkomen en communicatievaardigheden binnen uw organisatie te ontwikkelen.",
        features: [
          "Conflictmanagement workshops",
          "Training communicatievaardigheden",
          "Geweldloze communicatie benadering",
          "Preventieve strategieontwikkeling"
        ]
      }
    },
    
    // Team Section
    team: {
      title: "Onze gecertificeerde bemiddelaars",
      members: [
        // TEMPORAIREMENT MASQUÉ - Doris Sessolo
        // {
        //   name: "Doris Sessolo",
        //   role: "Partner",
        //   bio: "Doris is gespecialiseerd in teambemiddeling en sociale relaties en brengt een diepgaand begrip van werkplekdynamiek en conflictoplossing mee. Haar empathische aanpak helpt harmonie in professionele omgevingen te herstellen."
        // },
        {
          name: "Christophe Cogels",
          role: "Partner",
          bio: "Christophe heeft uitgebreide ervaring in de zakenwereld en organisatorisch conflictbeheer. Hij is gespecialiseerd in het ondersteunen van familiebedrijven, een omgeving waar economische uitdagingen verweven zijn met emotionele en relationele dynamieken.\n\nZijn interventiegebieden omvatten:\n• Aandeelhoudersconflicten en governance-kwesties,\n• Geschillen met klanten en leveranciers, vaak versterkt door reputatie- of bedrijfscontinuïteitskwesties,\n• Sociale conflicten binnen KMO's, inclusief sociale dialoog, interne spanningen en gevoelige herstructureringen.\n\nChristophe heeft een investeringsbank en verschillende KMO's geleid, wat hem een verfijnd begrip geeft van de operationele, financiële en menselijke realiteiten waarmee bedrijfsleiders worden geconfronteerd. Hij is een gecertificeerde bemiddelaar door de Federale Bemiddelingscommissie in civiele en commerciële, sociale en familiale aangelegenheden.\n\nDaarnaast leidt hij een vzw die zich inzet voor het behoud van sociale banden binnen families, wat zijn alomvattende benadering van relationele dynamiek versterkt, zowel professioneel als privé."
        }
        // TEMPORAIREMENT MASQUÉ - Michel Caldana
        // {
        //   name: "Michel Caldana",
        //   role: "Partner",
        //   bio: "Michel is bemiddelaar in civiele en commerciële bemiddeling en sociale bemiddeling.\n\nMet een achtergrond als burgerlijk ingenieur brengt Michel vandaag meer dan dertig jaar ervaring in het analyseren van complexe situaties en het begeleiden van bedrijfsleiders ten dienste van bemiddeling. Zijn carrière, die industrie, bedrijfsleiding, consulting en gerechtelijke functies combineert, heeft hem in staat gesteld expertise te ontwikkelen in het begrijpen van technische, economische en juridische vraagstukken, met name in de context van bedrijven in moeilijkheden.\n\nLekenrechter bij de Ondernemingsrechtbank van Waals-Brabant sinds 2018, zetelt hij met name in de minnelijke schikkingskamer, waar hij partijen begeleidt bij het zoeken naar onderhandelde oplossingen. Houder van een interuniversitair certificaat in bemiddeling (UCLouvain), heeft hij actief luisteren, herformulering en spanningsbeheer tot het hart van zijn praktijk gemaakt.\n\nZijn diepgaande kennis van faillissements- en gerechtelijke reorganisatiemechanismen, gecombineerd met zijn ervaring in het begeleiden van leiders in gevoelige contexten, stelt hem in staat snel een vertrouwensklimaat te creëren met belanghebbenden in moeilijkheden en hen te helpen constructieve oplossingen te identificeren.\n\nHij werkt voornamelijk in civiele en commerciële bemiddeling, met bijzondere aandacht voor situaties waarbij bedrijven en hun leiders betrokken zijn."
        // }
      ]
    },
    
    // FAQ Section
    faq: {
      title: "Veelgestelde vragen",
      items: [
        {
          question: "Wat is bedrijfsbemiddeling?",
          answer: "Bedrijfsbemiddeling is een vertrouwelijk proces waarbij een neutrale derde partij bedrijven helpt geschillen op te lossen via gefaciliteerde onderhandelingen, waardoor kostbare rechtszaken worden vermeden."
        },
        {
          question: "Hoe lang duurt bemiddeling meestal?",
          answer: "De meeste bemiddelingen worden opgelost binnen 3-5 sessies, afhankelijk van de complexiteit van het geschil. Elke sessie duurt doorgaans 2-4 uur. Het schema van sessies wordt georganiseerd tussen de partijen en de bemiddelaar."
        },
        {
          question: "Is bemiddeling juridisch bindend?",
          answer: "Bemiddelingsovereenkomsten kunnen juridisch bindend worden gemaakt. Onze bemiddelaars zijn gecertificeerd door de Federale Bemiddelingscommissie en kunnen helpen bij het opstellen van afdwingbare schikkingsovereenkomsten."
        },
        {
          question: "Wat zijn de kosten van bemiddeling?",
          answer: "De kosten variëren op basis van de complexiteit en duur van de bemiddeling. De kosten worden gedeeld tussen de partijen en dit is onderwerp van een overeenkomst. Neem contact met ons op voor een gedetailleerde offerte op maat van uw specifieke situatie."
        },
        {
          question: "Waar vinden de bemiddelingen plaats?",
          answer: "Bemiddelingen moeten plaatsvinden op een neutrale locatie. Deze moet zo dicht mogelijk bij de partijen zijn en onze bemiddelaars reizen door heel België."
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: "Plan een consultatie",
      subtitle: "Deze eerste kennismaking is gratis en stelt u in staat te begrijpen wat bemiddeling u kan brengen. We verbinden ons ertoe u binnen 24 uur te contacteren. Voorzien 1/2 uur.",
      form: {
        fullName: "Volledige naam",
        email: "E-mailadres",
        phone: "Telefoonnummer",
        company: "Bedrijfsnaam",
        disputeType: "Type geschil",
        preferredDay: "Voorkeur dag",
        preferredTime: "Voorkeur tijd",
        alternativeSlots: "Alternatieve tijdslots",
        additionalInfo: "Aanvullende informatie",
        placeholder: "Als er andere niet-vertrouwelijke elementen zijn die u in dit stadium wilt delen, kunt u ze ons hier meedelen. Sommige bemiddelingen vereisen een snelle start. Aarzel niet om dit te vermelden indien nodig.",
        selectType: "Selecteer type geschil",
        selectDay: "Selecteer een dag",
        selectTime: "Selecteer een tijdslot",
        types: {
          shareholder: "Aandeelhoudersgeschil",
          client: "Klantgeschil",
          supplier: "Leveranciersconflict",
          social: "Sociale bemiddeling",
          training: "Bedrijfstraining",
          other: "Anders"
        },
        submit: "Boek consultatie",
        submitting: "Bezig met verzenden...",
        required: " *"
      }
    },
    
    // Contact Section
    contact: {
      title: "Neem contact op",
      subtitle: "Heeft u vragen? We helpen u graag",
      info: {
        title: "Contactinformatie",
        email: "E-mail",
        phone: "Telefoon",
        location: "Locatie",
        locationValue: "België"
      },
      form: {
        title: "Stuur ons een bericht",
        name: "Naam",
        email: "E-mail",
        phone: "Telefoon",
        message: "Bericht",
        submit: "Verstuur bericht",
        submitting: "Verzenden...",
        required: " *"
      }
    },
    
    // Footer
    footer: {
      description: "Professionele bedrijfsbemiddelingsdiensten voor bedrijven.",
      quickLinks: "Snelle links",
      contact: "Contact",
      copyright: "Alle rechten voorbehouden."
    },
    
    // Toast Messages
    toast: {
      contactSuccess: "Bedankt voor uw bericht. We nemen binnen 24 uur contact met u op.",
      bookingSuccess: "Uw consultatie is ingepland. U ontvangt binnenkort een bevestigingsmail.",
      error: "Er is een fout opgetreden. Probeer het opnieuw."
    }
  }
};

export const firmInfo = {
  name: "Mediation Partners",
  fullName: "Mediation Partners - Mediation & Advisory for complex situations",
  tagline: "Mediation & Advisory for complex situations",
  shortName: "Mediation Partners",
  email: "info@mediationpartners.be",
  phone: "+32 475 82 50 89",
  teamMembers: [
    // TEMPORAIREMENT MASQUÉ - Doris Sessolo
    // { 
    //   name: "Doris Sessolo", 
    //   role: "partner",
    //   email: "doris.sessolo@mediationpartners.be",
    //   phone: "+32 478 21 44 33"
    // },
    { 
      name: "Christophe Cogels", 
      role: "partner",
      email: "c.cogels@mediationpartners.be",
      phone: "+32 475 82 50 89"
    }
    // TEMPORAIREMENT MASQUÉ - Michel Caldana
    // { 
    //   name: "Michel Caldana", 
    //   role: "partner",
    //   email: "michel.caldana@mediationpartners.be",
    //   phone: "+32 475 85 24 34"
    // }
  ]
};
